const useFAQ = () => {
  const faqTitles = document.querySelectorAll('.faq__item-title')
  const faqItems = document.querySelectorAll('.faq__item')

  faqTitles.forEach((item) => {
    item.addEventListener('click', function () {
      const parentElement = this.parentElement
      const content = parentElement.querySelector('.faq__item-content')

      if (parentElement.classList.contains('active')) {
        content.style.height = `${content.scrollHeight}px`
        setTimeout(() => {
          content.style.height = '0'
          parentElement.classList.remove('active')
        }, 10)
      } else {
        faqItems.forEach((item) => {
          item.classList.remove('active')
          item.querySelector('.faq__item-content').style.height = '0'
        })

        parentElement.classList.add('active')
        content.style.height = `${content.scrollHeight}px`
      }
    })
  })
}

export default useFAQ
